import type { ReactNode } from "react";

import { MarketTicker } from "@/app/shell/MarketTicker";
import { SiteFooter } from "@/site/SiteFooter";
import { SiteHeader } from "@/site/SiteHeader";

/** The public site's chrome (header, optional ticker, footer) around a page. */
export function SiteFrame({ children, ticker = false }: { children: ReactNode; ticker?: boolean }) {
  return (
    <div className="flex min-h-safe flex-col bg-surface">
      <SiteHeader />
      {ticker ? <MarketTicker source="/public/ticker" /> : null}
      <main id="main" className="site-wrap w-full min-w-0 flex-1 py-4 sm:py-6">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
